import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  "data-testid": "import-result",
  class: "flex flex-col py-6 gap-6"
}
const _hoisted_2 = { class: "flex flex-col items-center gap-2" }
const _hoisted_3 = { class: "text-textPrimary text-lg font-bold" }
const _hoisted_4 = { class: "flex justify-center gap-8" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col items-center gap-1"
}
const _hoisted_6 = {
  "data-testid": "import-result-imported",
  class: "text-2xl font-bold text-feedBackSuccess"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutralLight" }, "importadas", -1)
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col items-center gap-1"
}
const _hoisted_9 = {
  "data-testid": "import-result-rejected",
  class: "text-2xl font-bold text-feedBackAlert"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutralLight" }, "rejeitadas", -1)
const _hoisted_11 = {
  key: 2,
  class: "flex flex-col items-center gap-1"
}
const _hoisted_12 = {
  "data-testid": "import-result-merged-duplicates",
  class: "text-2xl font-bold text-primary30"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutralLight" }, "duplicatas mescladas", -1)
const _hoisted_14 = {
  key: 0,
  class: "border rounded-lg overflow-clip border-lightGray30"
}
const _hoisted_15 = { class: "bg-gray-50 px-4 py-2 border-b border-lightGray30 flex items-center justify-between" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold text-textPrimary" }, "Linhas rejeitadas", -1)
const _hoisted_17 = { class: "max-h-[400px] overflow-y-auto overflow-x-auto" }
const _hoisted_18 = {
  class: "w-full text-sm",
  "aria-label": "Linhas rejeitadas na importação"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky top-0 bg-gray-50 border-b border-lightGray30" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left px-4 py-2 text-neutralLight font-medium w-16" }, "Linha"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left px-4 py-2 text-neutralLight font-medium w-28" }, "CRM"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left px-4 py-2 text-neutralLight font-medium w-16" }, "UF"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left px-4 py-2 text-neutralLight font-medium" }, "Motivo")
  ])
], -1)
const _hoisted_20 = ["data-testid"]
const _hoisted_21 = { class: "text-left px-4 py-2 text-textPrimary" }
const _hoisted_22 = { class: "text-left px-4 py-2 text-textPrimary font-mono" }
const _hoisted_23 = { class: "text-left px-4 py-2 text-textPrimary" }
const _hoisted_24 = { class: "text-left px-4 py-2 text-textPrimary" }
const _hoisted_25 = {
  key: 0,
  class: "bg-feedBackAlert/10 px-4 py-2 border-t border-lightGray30"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-feedBackAlert" }, " Existem mais linhas rejeitadas que não foram exibidas. ", -1)
const _hoisted_27 = [
  _hoisted_26
]

import { computed } from 'vue'
import { mdiCheckCircleOutline, mdiAlertCircleOutline, mdiDownload } from '@mdi/js'

import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import type { ImportReportError } from '@/Network/Types/Responses/QualificationPolicyResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'StepResult',
  props: {
    imported: {},
    rejected: {},
    mergedDuplicates: {},
    errors: {},
    errorsTruncated: { type: Boolean },
    policyId: {},
    policyName: {}
  },
  setup(__props: any) {

const props = __props;



const sortedErrors = computed(() => [...props.errors].sort((a, b) => a.row - b.row))

function escapeCsvField(value: string): string {
  let escaped = value
  if (/^[=+\-@]/.test(escaped)) escaped = `'${escaped}`
  if (escaped.includes('"') || escaped.includes(';') || escaped.includes('\n')) {
    return `"${escaped.replace(/"/g, '""')}"`
  }
  return escaped
}

function handleExportRejected() {
  const BOM = '\uFEFF'
  const header = 'Linha;CRM;UF;Motivo'
  const rows = props.errors.map(
    (e) =>
      `${e.row};${escapeCsvField(e.crm || '')};${escapeCsvField(e.uf || '')};${escapeCsvField(e.message)}`
  )
  const csv = BOM + [header, ...rows].join('\n')

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  const now = new Date()
  const timestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}h${String(now.getMinutes()).padStart(2, '0')}`
  const slug = props.policyName
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
  link.setAttribute('download', `rejeitados-#${props.policyId}-${slug}-${timestamp}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        icon: _ctx.imported > 0 ? _unref(mdiCheckCircleOutline) : _unref(mdiAlertCircleOutline),
        size: "56",
        class: _normalizeClass(_ctx.imported > 0 ? 'text-feedBackSuccess' : 'text-feedBackAlert')
      }, null, 8, ["icon", "class"]),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.imported > 0 ? 'Importação concluída!' : 'Nenhuma validação importada'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.imported > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.imported.toLocaleString('pt-BR')), 1),
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (_ctx.rejected > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.rejected.toLocaleString('pt-BR')), 1),
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      (_ctx.mergedDuplicates > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.mergedDuplicates.toLocaleString('pt-BR')), 1),
            _hoisted_13
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.errors.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(OutlinedButton, {
              "data-testid": "export-rejected-button",
              text: "Exportar",
              width: "auto",
              height: "32px",
              "prepend-icon": _unref(mdiDownload),
              class: "!border-primary30 !text-primary30 !text-xs !px-3",
              onClick: handleExportRejected
            }, null, 8, ["prepend-icon"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("table", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedErrors.value, (error, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    "data-testid": `import-error-row-${index}`,
                    class: "border-b last:border-b-0 border-lightGray30"
                  }, [
                    _createElementVNode("td", _hoisted_21, _toDisplayString(error.row), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(error.crm || '—'), 1),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(error.uf || '—'), 1),
                    _createElementVNode("td", _hoisted_24, _toDisplayString(error.message), 1)
                  ], 8, _hoisted_20))
                }), 128))
              ])
            ])
          ]),
          (_ctx.errorsTruncated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})